import { NativeSelect } from "shared/components/Spor";
import styled from "styled-components";

// Styled NativeSelect with increased specificity of the option selector to override chakra global option styles
// https://developer.mozilla.org/en-US/docs/Web/CSS/Specificity#increasing_specificity_by_duplicating_selector
export const Select = styled(NativeSelect)`
  &&& option {
    background: ${({ theme }) => theme.colorBackgroundSecondary};
    color: inherit;
  }
  &&& optgroup {
    background: ${({ theme }) => theme.colorBackgroundSecondary};
    color: inherit;
  }
`;
